<app-breadcrumb [title]="'Inspecciones de la Zona'" [items]="['Pesv', 'Zonas de vías']"
  [active_item]="zonaActual?.nombre || 'Inspecciones de vías'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between bg-primary text-white">
      <div class="d-flex align-items-center">
        <i class="fa fa-search me-2"></i>
        <h5 class="mb-0"><strong>INSPECCIONES DE LA ZONA {{ zonaActual?.codigo }} - {{ zonaActual?.nombre }}</strong></h5>
      </div>
      <button type="button" class="btn btn-light btn-sm" (click)="volver()">
        <i class="fa fa-arrow-left me-1"></i>Volver a zonas
      </button>
    </div>

    <div class="card-body">
      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 1" (click)="activeTab = 1">
            <i class="fa fa-plus me-1"></i>{{ editando ? 'Editar inspección' : 'Registrar inspección' }}
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 2" (click)="mostrarListado()">
            <i class="fa fa-list me-1"></i>Listado de inspecciones
          </button>
        </li>
      </ul>

      <form *ngIf="activeTab === 1" [formGroup]="form" (ngSubmit)="guardar()">
        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-info-circle me-2"></i>
            1. Información general
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-6">
              <label class="form-label">Vía interna:</label>
              <input type="text" class="form-control" [value]="nombreVia(zonaActual?.via_id)" readonly />
            </div>

            <div class="col-md-6">
              <label class="form-label">Zona:</label>
              <input type="text" class="form-control" [value]="zonaActual?.codigo + ' - ' + zonaActual?.nombre" readonly />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Código: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="codigo" placeholder="INS-001" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Fecha de inspección: <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="fecha_inspeccion" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Tipo de inspección: <span class="text-danger">*</span></label>
              <ng-select [items]="tiposInspeccion" bindLabel="descripcion" bindValue="id" placeholder="Seleccione un tipo" formControlName="tipo_inspeccion"
                [clearable]="true" [searchable]="false">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Motivo: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="tiposMotivo" bindLabel="descripcion" bindValue="id" placeholder="Seleccione un motivo" formControlName="motivo"
                [clearable]="true" [searchable]="false">
              </ng-select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Riesgo asociado: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="riesgosDeZona" bindLabel="codigo" bindValue="id" placeholder="Seleccione un riesgo de la zona"
                formControlName="riesgo_id" notFoundText="La zona no tiene riesgos registrados">
              </ng-select>
            </div>

            <div class="col-md-6">
              <label class="form-label">Inspector: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="colaboradores" bindLabel="nombreConCargo" bindValue="cedula"
                [loading]="cargandoColaboradores" placeholder="Seleccione un inspector" formControlName="inspector_id"
                [clearable]="true" [searchable]="true">
              </ng-select>
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-cloud me-2"></i>
            2. Condiciones y resultado
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-4">
              <label class="form-label">Condiciones climáticas: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="opcionesCondicionesClimaticas" bindLabel="nombre" bindValue="id" placeholder="Seleccione una condición"
                formControlName="condiciones_climaticas" [clearable]="true" [searchable]="false">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Condiciones de operación: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="opcionesCondicionesOperacion" bindLabel="descripcion" bindValue="id" placeholder="Seleccione una condición"
                formControlName="condiciones_operacion" [clearable]="true" [searchable]="false">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Resultado: <span class="text-dark">(Opcional)</span></label>
              <ng-select [items]="resultados" bindLabel="descripcion" bindValue="id" placeholder="Seleccione un resultado"
                formControlName="resultado" [clearable]="true" [searchable]="false">
              </ng-select>
            </div>

            <div class="col-md-12">
              <label class="form-label">Observaciones: <span class="text-dark">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="observaciones"></textarea>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-light border text-secondary px-4"
              (click)="cancelar()">Cancelar</button>

            <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">{{ guardando ? 'Guardando...' :
              'Guardar' }}</button>
          </div>
        </div>
      </form>

      <div *ngIf="activeTab === 2">
        <div class="row mb-3 align-items-center">
          <div class="col-md-4">
            <input type="search" class="form-control" [(ngModel)]="filtro" (input)="aplicarFiltro()"
              placeholder="Buscar por código, tipo o resultado..." />
          </div>
        </div>

        <div *ngIf="cargandoListado" class="text-center py-4">
          <span class="spinner-border text-primary"></span>
          <p class="mt-2 mb-0">Cargando inspecciones...</p>
        </div>

        <div *ngIf="!cargandoListado" class="table-responsive">
          <table id="tblViasInspecciones" class="table table-bordered table-hover align-middle">
            <thead class="bg-primary text-white">
              <tr>
                <th class="text-center">CÓDIGO</th>
                <th class="text-center">TIPO</th>
                <th class="text-center">MOTIVO</th>
                <th class="text-center">FECHA INSPECCIÓN</th>
                <th class="text-center">INSPECTOR</th>
                <th class="text-center">RESULTADO</th>
                <th class="text-center">ESTADO</th>
                <th class="text-center">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let inspeccion of inspeccionesFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                <td class="text-center">{{ inspeccion.codigo }}</td>
                <td class="text-center">{{ inspeccion.InspeccionTipoData?.descripcion }}</td>
                <td class="text-center">{{ inspeccion.InspeccionMotivoData?.descripcion }}</td>
                <td class="text-center">{{ formatearFecha(inspeccion.fecha_inspeccion) }}</td>
                <td class="text-center">{{ nombreInspector(inspeccion.inspector_id) }}</td>
                <td class="text-center">
                  <span *ngIf="inspeccion.resultado" class="badge" [ngClass]="claseResultado(inspeccion.resultado)">
                    {{ inspeccion.InspeccionResultadoData?.descripcion }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="badge" [ngClass]="Number(inspeccion.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                    {{ Number(inspeccion.estado) === 1 ? 'ACTIVA' : 'INACTIVA' }}
                  </span>
                </td>
                <td class="text-center">
                    <button type="button" class="btn btn-sm btn-outline-primary me-1 rounded-pill btn-rounded"
                    (click)="editarInspeccion(inspeccion)" [disabled]="Number(inspeccion.estado) !== 1" title="Editar">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-primary me-1 rounded-pill btn-rounded"
                    (click)="verHallazgos(inspeccion)" title="Ver Hallazgos">
                    <i class="fa fa-eye"></i>
                  </button>
                  <button type="button" class="btn btn-sm me-1 rounded-pill btn-rounded"
                    [ngClass]="Number(inspeccion.estado) === 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                    (click)="cambiarEstado(inspeccion)" [title]="Number(inspeccion.estado) === 1 ? 'Inactivar' : 'Activar'">
                    <i class="fa" [ngClass]="Number(inspeccion.estado) === 1 ? 'fa-ban' : 'fa-check'"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!inspeccionesFiltradas.length">
                <td colspan="8" class="text-center text-primary py-4">No hay inspecciones registradas.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4" *ngIf="inspeccionesFiltradas.length > 0">
          <div class="d-flex align-items-center">
            <label class="me-2">Mostrar:</label>
            <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>
          <div class="text-center flex-grow-1">
            Total Registros: <a class="badge badge-primary"><b>{{ inspeccionesFiltradas?.length || 0 }}</b></a>
          </div>
          <div class="text-end paginador-personalizado">
            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
              [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
          </div>
        </div>

        <div class="btn-showcase text-center mt-4" *ngIf="inspeccionesFiltradas.length">
          <button type="button" class="btn btn-outline-success-2x me-2" (click)="exportarExcel()">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>
          <button type="button" class="btn btn-outline-danger-2x" (click)="exportarPdf()">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>